<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Tarih Aralığı</label>
            <flat-pickr v-on:on-change="setDate" v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',mode:'range', dateFormat: 'Y-m-d',locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>        
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Hata Sebebi</label>
            <v-select-list :options="reasons" label="text" v-model="reason" placeholder="Hata Sebebi"></v-select-list>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Plaka Durumu</label>
            <v-select-list :options="plateStatuses" label="status" v-model="c_plateStatus" placeholder="Plaka Durumu"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filter)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 

export default {
    components:{
        flatPickr
    },
    data(){
        return{
            reasons:[
                {text:"Tümü",value:null},
                {text:"Envanterde Yok",value:0},
                {text:"Satılmış Plaka",value:1},
            ],
            plateStatuses:[
                {status:'Tümü',value:null},
                {status:'Bilgi Var',value:true},
                {status:'Bilgi Yok',value:false},
            ],
            dateRange:null,
            filter:{
                HasVehiclePlateInfo:null,
                StartDate:null,
                EndDate:null,
                WrongPlateReason:null
            }
        }
    },
    methods:{
        clearForm(){
            this.dateRange = null
            this.filter.WrongPlateReason = null
            this.filter.HasVehiclePlateInfo = null
            this.$emit('filter',this.filter)
        },
        setDate(){    
            this.filter.StartDate = this.dateRange?.split(' - ')[0] || null,
            this.filter.EndDate = this.dateRange?.split(' - ')[1] || null
        }
    },
    computed:{
        c_plateStatus:{
            get:function(){
                return this.plateStatuses.find(s=>s.value==this.filter.HasVehiclePlateInfo)
            },
            set:function(value){
                this.filter.HasVehiclePlateInfo = value?.value != "undefined" ? value?.value :  null
            }
        },
        reason:{
            get:function(){
                return this.reasons.find(s=>s.value==this.filter.WrongPlateReason)
            },
            set:function(value){
                this.filter.WrongPlateReason = value?.value != "undefined" ? value?.value :  null
            }
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>